import { Check } from "lucide-react";

/**
 * Iter-165 — Trust microcopy strip above the primary "Compare Options" CTA.
 *
 * Subtle, premium check-marked chips that explicitly counter the three
 * objections the post-submit user most commonly has at this moment:
 *   1. "Is this going to cost me?"   → ✓ Free to compare
 *   2. "Will this ding my credit?"   → ✓ Soft credit pull options
 *   3. "Will my phone get blown up?" → ✓ No spam calls
 *
 * Renders as a single horizontally-wrapping line on mobile + a clean row
 * on desktop. No color, no border — just the emerald check + slate-600
 * label so the visual stack stays calm against the primary CTA below.
 */
export default function TrustChips() {
  const chips = [
    "Free to compare",
    "Soft credit pull options",
    "No spam calls",
    "No obligation",
  ];
  return (
    <div
      data-testid="funnel-trust-chips"
      className="flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[11px] text-slate-600"
    >
      {chips.map((chip) => (
        <span
          key={chip}
          className="inline-flex items-center gap-1.5"
          data-testid={`trust-chip-${chip.toLowerCase().replace(/\s+/g, "-")}`}
        >
          <Check
            className="w-3 h-3 text-[#10B981]"
            strokeWidth={3}
            aria-hidden="true"
          />
          <span className="font-medium">{chip}</span>
        </span>
      ))}
    </div>
  );
}
